export var Environments;
(function (Environments) {
    Environments["test"] = "test";
    Environments["development"] = "development";
    Environments["staging"] = "staging";
    Environments["prod"] = "prod";
    Environments["production"] = "production";
})(Environments || (Environments = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic25vd3Bsb3cuZW51bXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi9zcmMvbGliL3Nub3dwbG93LmVudW1zLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUFBLE1BQU0sQ0FBTixJQUFZLFlBTVg7QUFORCxXQUFZLFlBQVk7SUFDdEIsNkJBQWEsQ0FBQTtJQUNiLDJDQUEyQixDQUFBO0lBQzNCLG1DQUFtQixDQUFBO0lBQ25CLDZCQUFhLENBQUE7SUFDYix5Q0FBeUIsQ0FBQTtBQUMzQixDQUFDLEVBTlcsWUFBWSxLQUFaLFlBQVksUUFNdkIifQ==